/* tslint:disable */
import { Injectable } from '@angular/core';
import {
  HttpClient, HttpRequest, HttpResponse,
  HttpHeaders, HttpParams
} from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { Observable } from 'rxjs/Observable';
import { map } from 'rxjs/operators/map';
import { filter } from 'rxjs/operators/filter';

@Injectable()
export class ManagerTicketCountriesService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  getFormDataResponse(): Observable<HttpResponse<any>> {
    const __params = this.newParams();
    const __headers = new HttpHeaders();
    const __body: any = null;

    const req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/manager/ticket-countries`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      }
    );

    return this.http.request<any>(req).pipe(
      filter(_r => _r instanceof HttpResponse),
      map(_r => {
        const _resp = _r as HttpResponse<any>;
        return _resp.clone({ body: _resp.body }) as HttpResponse<any>;
      })
    );
  }

  getFormData(): Observable<any> {
    return this.getFormDataResponse().pipe(map(_r => _r.body));
  }

  /**
   * GET /manager/ticket-countries/tickets
   */
  listTicketsResponse(params?: {
    from_date?: string;
    to_date?: string;
    price_id?: any;
    ticket_type_id?: any;
    search_type?: string;
    serial_start?: any;
    serial_end?: any;
    fkey?: string;
  }): Observable<HttpResponse<any>> {
    let __params = this.newParams();
    const __headers = new HttpHeaders();
    const __body: any = null;

    if (params) {
      if (params.from_date != null) {
        __params = __params.set('from_date', '' + params.from_date);
      }
      if (params.to_date != null) {
        __params = __params.set('to_date', '' + params.to_date);
      }
      if (params.price_id != null && params.price_id !== '') {
        __params = __params.set('price_id', '' + params.price_id);
      }
      if (params.ticket_type_id != null && params.ticket_type_id !== '') {
        __params = __params.set('ticket_type_id', '' + params.ticket_type_id);
      }
      if (params.search_type != null) {
        __params = __params.set('search_type', '' + params.search_type);
      }
      if (params.serial_start != null && params.serial_start !== '') {
        __params = __params.set('serial_start', '' + params.serial_start);
      }
      if (params.serial_end != null && params.serial_end !== '') {
        __params = __params.set('serial_end', '' + params.serial_end);
      }
      if (params.fkey != null && params.fkey !== '') {
        __params = __params.set('fkey', '' + params.fkey);
      }
    }

    const req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/manager/ticket-countries/tickets`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      }
    );

    return this.http.request<any>(req).pipe(
      filter(_r => _r instanceof HttpResponse),
      map(_r => {
        const _resp = _r as HttpResponse<any>;
        return _resp.clone({ body: _resp.body }) as HttpResponse<any>;
      })
    );
  }

  listTickets(params?: any): Observable<any> {
    return this.listTicketsResponse(params).pipe(map(_r => _r.body));
  }

  updateTicketCountryResponse(payload: any): Observable<HttpResponse<any>> {
    const __params = this.newParams();
    const __headers = new HttpHeaders();
    const __body: any = payload || {};

    const req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/manager/ticket-countries/update`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      }
    );

    return this.http.request<any>(req).pipe(
      filter(_r => _r instanceof HttpResponse),
      map(_r => {
        const _resp = _r as HttpResponse<any>;
        return _resp.clone({ body: _resp.body }) as HttpResponse<any>;
      })
    );
  }

  updateTicketCountry(payload: any): Observable<any> {
    return this.updateTicketCountryResponse(payload).pipe(map(_r => _r.body));
  }
}
